import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  constructor(private http: HttpClient) {}

  getTimezones(): Observable<any[]> {
    return this.http.get<any[]>('/assets/timezones.json');
  }
}
